import { getDistance } from "geolib"
import moment from "moment"
import { stripHtml } from "string-strip-html"

import { Locale } from "../../i18n/locale"
import { safeHtml } from "../../util/safe-html"
import { toUrl } from "../../util/urls"
import { CareerContactModel } from "../careerContactModel"
import { GoogleMapsLocationModel } from "../googleMapsLocationModel"
import { MunzingLocationModel } from "../munzingLocationModel"

export class SoftgardenJobModel {
  constructor(el = {}, munzingLocations = [], careerContacts = []) {
    this.id = el.id
    this.jobDbId = el.jobDbId
    this.externalPostingName = el.externalPostingName
    this.internalPostingName = el.internalPostingName
    this.applyOnlineLink = el.applyOnlineLink
    this.jobCategories = el.jobCategories || []
    this.audiences = el.audiences || []
    this.employmentTypes = el.employmentTypes || []
    this.workTimes = el.workTimes || []
    this.industries = el.industries || []
    this.workExperiences = el.workExperiences || []
    this.geo_lat = el.geo_lat
    this.geo_long = el.geo_long
    this.geo_name = el.geo_name
    this.geo_country = el.geo_country
    this.geo_state = el.geo_state
    this.geo_city = el.geo_city
    this.geo_zip = el.geo_zip
    this.geo_street = el.geo_street
    this.jobAdText = safeHtml(el.jobAdText || "").replace(
      /<div[^>]*>\s+<\/div>/g,
      "",
    )
    this.internalJobAdText = el.internalJobAdText
    this.jobStartDate = moment(parseInt(el.jobStartDate))
    this.postingLastUpdatedDate = moment(parseInt(el.postingLastUpdatedDate))
    this.job_owner_salutation = el.job_owner_salutation
    this.job_owner_title = el.job_owner_title
    this.job_owner_firstname = el.job_owner_firstname
    this.job_owner_lastname = el.job_owner_lastname
    this.job_owner_street = el.job_owner_street
    this.job_owner_city = el.job_owner_city
    this.job_owner_zip = el.job_owner_zip
    this.job_owner_phone = el.job_owner_phone
    this.job_owner_email = el.job_owner_email
    this.job_owner_avatarurl = el.job_owner_avatarurl
    this.job_owner_function = el.job_owner_function
    this.job_ad_url = el.job_ad_url
    this.jobAdImg = el.jobAdImg
    this.jobOwnerAvatarurl = el.jobOwnerAvatarurl
    this.company_name = el.company_name
    this.company_id = el.company_id
    this.project_number = el.project_number
    this.internal_reference_id = el.internal_reference_id
    this.locale = el.locale
    this.keywords = el.keywords
    this.remote_status = el.remote_status

    this.description = stripHtml(this.jobAdText || "").result

    if (munzingLocations.length > 0 && this.geo_lat && this.geo_long) {
      const sortedLocations = munzingLocations.sort((a, b) => {
        return (
          getDistance(
            { latitude: +this.geo_lat, longitude: +this.geo_long },
            {
              latitude: a.location.geometry.location.lat,
              longitude: a.location.geometry.location.lng,
            },
          ) -
          getDistance(
            { latitude: +this.geo_lat, longitude: +this.geo_long },
            {
              latitude: b.location.geometry.location.lat,
              longitude: b.location.geometry.location.lng,
            },
          )
        )
      })

      const closestLocation = sortedLocations[0]
      const distanceToClosestLocation = getDistance(
        { latitude: +this.geo_lat, longitude: +this.geo_long },
        {
          latitude: closestLocation.location.geometry.location.lat,
          longitude: closestLocation.location.geometry.location.lng,
        },
      )

      if (distanceToClosestLocation < 1000) {
        console.log(distanceToClosestLocation)
        this.locations = [closestLocation]
      } else {
        const googleMapsLocation = Object.assign(
          new GoogleMapsLocationModel({
            geometry: {
              location: {
                lat: +this.geo_lat,
                lng: +this.geo_long,
              },
            },
          }),
          {
            getFormattedPlaceName: () => ``,
            getFormattedAddress: () => ``,
          },
        )

        this.locations = [
          new MunzingLocationModel({
            location: googleMapsLocation,
            locationName: this.geo_name,
            name: { key: this.geo_name },
          }),
        ]
      }
    } else {
      this.locations = []
    }

    this.contactPerson = CareerContactModel.getCareerContactsByNames(
      careerContacts,
      [[this.job_owner_firstname, this.job_owner_lastname]],
    )[0]

    let image
    if (this.jobOwnerAvatarurl) {
      image = this.jobOwnerAvatarurl.childImageSharp.gatsbyImageData
    }

    if (!this.contactPerson) {
      this.contactPerson = new CareerContactModel({
        id: `job-${this.id}-contact`,
        gatsbyImage: image,
        responsibility: this.job_owner_function,
        quote: undefined,
        name: `${this.job_owner_title || ""} ${this.job_owner_firstname} ${
          this.job_owner_lastname
        }`.trim(),
        phone: this.job_owner_phone,
        email: this.job_owner_email,
      })
    } else {
      if (!this.contactPerson.gatsbyImage) {
        this.contactPerson.gatsbyImage = image
      }
    }
  }

  getPageUrl() {
    return toUrl(`/career/open-vacancies/${this.jobDbId}/`)
  }

  isStudiesAndTraining() {
    const studiesAndTrainingIds = [
      "00001",
      "3a3ab7987f000002010ad4925ffa0cf4",
      "6179d1a00a0b0cce01ed3de8643a0e39",
    ]

    return (
      this.audiences[0] && studiesAndTrainingIds.includes(this.audiences[0])
    )
  }

  getJobFeaturesStrings(locale) {
    return [
      // ...this.jobCategories,

      ...this.employmentTypes,
      ...this.workTimes,
      // ...this.industries,
      // ...this.audiences,
      ...this.workExperiences,
    ].map((el) => SoftgardenJobModel.getTranslatedCatalogValue(el, locale))
  }

  static getTranslatedCatalogValue(catalogValue, locale) {
    const localeObj = new Locale(locale)

    if (!catalogValue) {
      return ""
    }

    return (
      catalogValue.translations[localeObj.getLocaleKey()] ||
      catalogValue.translations["en"] ||
      ""
    )
  }
}
